import { BaseComponent, IStateBase } from 'components/BaseComponent';
import PaymentMethod from 'components/Cart/PaymentMethod';
import * as React from 'react';
import PaymentForm from './PaymentForm';
import { paymentService } from 'services/PaymentService';
import { cartService } from 'services/CartService';
import { ICartModel } from 'interfaces/ICartModel';
import Button from '@material-ui/core/Button/Button';
import Translate from 'components/Translate';
import { IProductData } from 'interfaces/IProductData';

interface IProps {
  index: number;
  cardFlagLimit?: number;
  hidePaymentMessage?: boolean;
  removeCreditCard?: any;
}

interface IState extends IStateBase {
  cart: ICartModel;
  productData: IProductData;
}

const styles = require('./payment.css');

export default class Payment extends BaseComponent<IState, IProps> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.observeState({ cart: null }, paymentService.getCart());
    this.observeState({ productData: null }, cartService.getCart());
  }

  removeCreditCard = () => {
    this.props.removeCreditCard();
    paymentService.removePayment(this.props.index);
  }

  render() {

    if (!this.state) {
      return <div />;
    }

    const { cart, productData } = this.state;
    let numberCreditCards = cart.payment.length;

    let hideMessage = false;
    if (!productData.config.enableCreditcard) {
      hideMessage = (productData.config.enableBankslip && productData.config.enablePaypal ? false : true);
    }

    return (
      <div className={`${styles.component} chk-payment ${this.props.index % 2 != 0 ? 'add-background' : ''}`}>
        {this.props.hidePaymentMessage || hideMessage
          ? null
          : <span className='chk-label method-label theme-label'>
            <Translate term='Selecione um método de pagamento' />
          </span>
        }

        {numberCreditCards > 1
          ? <div className='chk-multiple-cards-header'>
            <span className='chk-label payment-label'>
              <Translate term='Cartão de Crédito' /> #{this.props.index + 1}
            </span>
            <Button id='chk-remove-button' className='chk-remove-card theme-button' onClick={this.removeCreditCard}>
              <Translate term='Remover' />
            </Button>
          </div>
          : null
        }

        {hideMessage ?
          null
          : <PaymentMethod index={this.props.index} limit={this.props.cardFlagLimit} />
        }
        <PaymentForm index={this.props.index} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/MainForm/Payment/index.tsx